/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["*[_ngcontent-%COMP%]{font-size:14px}.title[_ngcontent-%COMP%]{color:#26273b}.price[_ngcontent-%COMP%]{color:#26273b;font-weight:700}.deliveryTime[_ngcontent-%COMP%]{color:#8e8fa6}span[_ngcontent-%COMP%]{display:inline-block;margin-right:10px}div[_ngcontent-%COMP%]{margin-top:8px}"];
export { styles as styles };
